import { analyticsService } from "@services/analyticsService";
import { WSAlert, WSElement } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { useNudgeDismissal } from "@hooks/useNudgeDismissal";
import { useOnVisible } from "../../../shared/hooks/useOnVisible";
import { PATH_ONBOARDING_TAX_WITHHOLDINGS } from "../../Onboarding";
import { useModalDismissTaxWithholdingsSetup } from "../modals/ModalDismissTaxWithholdingsSetup";
import { useModalPauseReminders } from "../modals/ModalPauseReminders";
import { useProposeTaxWithholdings } from "../hooks/useProposeTaxWithholdings";

export const AlertEnableTaxWithholdings: React.FC = () => {
  const history = useHistory();
  const queryFeatureFlags = useQueryFeatureFlags();
  const { propose, hasSetRate } = useProposeTaxWithholdings();
  const [dismissed] = useNudgeDismissal("taxWithholdingsAlerts");

  const modalDismissTaxWithholdingsSetup =
    useModalDismissTaxWithholdingsSetup();
  const modalPauseReminders = useModalPauseReminders();

  const handleDismiss = () => {
    modalDismissTaxWithholdingsSetup.open({
      onPauseReminders: () => {
        modalPauseReminders.open();
      }
    });
  };

  const showTaxWithholdingAlert =
    !!queryFeatureFlags.data?.taxWithholdingInvoicingAlerts &&
    !dismissed &&
    // Once a rate is saved the member has been through the flow, so
    // AlertEstimatedTaxWithholdings takes over from here.
    !hasSetRate &&
    propose;

  const [ref] = useOnVisible(() => {
    analyticsService.track("Invoicing Tax Withholdings Alert Viewed", {
      variant: "no_estimated_tax_rate"
    });
  });

  if (!showTaxWithholdingAlert) {
    return null;
  }

  return (
    <WSAlert
      theme="warning"
      icon="alert"
      title="You haven’t set up tax withholdings yet"
      action={{
        text: "Complete your setup",
        onClick: () => {
          analyticsService.track("Invoicing Tax Withholdings Alert Click", {
            variant: "no_estimated_tax_rate"
          });
          history.push(PATH_ONBOARDING_TAX_WITHHOLDINGS);
        }
      }}
      onDismiss={handleDismiss}
    >
      <WSElement ref={ref}></WSElement>
      As an independent contractor, you're considered self-employed by the IRS
      and responsible for income tax, self-employment tax, and quarterly
      payments. Avoid surprises at tax time by setting up your{" "}
      <b>tax withholdings</b> today to stay financially prepared.
    </WSAlert>
  );
};
